export const SCHEDULE_EVENT_TYPES = {
  PRIVATE: 'private',
  BLOCKED_TIME: 'blockedTime',
  FAMILY_GOLF: 'familyGolf',
  PGA_JR_LEAGUE: 'pgaJrLeague',
  GROUP_EVENT: 'groupEvent',
}

export const SCHEDULE_EVENT_COLORS = {
  [SCHEDULE_EVENT_TYPES.PRIVATE]: '#00205B',
  [SCHEDULE_EVENT_TYPES.BLOCKED_TIME]: '#70787C',
  [SCHEDULE_EVENT_TYPES.FAMILY_GOLF]: '#49C5B1',
  [SCHEDULE_EVENT_TYPES.PGA_JR_LEAGUE]: '#0077C8',
  [SCHEDULE_EVENT_TYPES.GROUP_EVENT]: '#C5A561',
}

const FAMILY_GOLF_TAGS = new Set([
  'Family Golf',
  'PGA Family Golf',
  'PGA Family Cup',
])

const PGA_JR_LEAGUE_TAGS = new Set(['PGA Jr. League'])

const BLOCKED_TIME_TYPENAMES = new Set([
  'CoachAvailabilityBlockTime',
  'BlockTime',
  'BlockedTime',
])

const hexToRgba = (hex, alpha) => {
  const normalized = hex.replace('#', '')
  const r = parseInt(normalized.slice(0, 2), 16)
  const g = parseInt(normalized.slice(2, 4), 16)
  const b = parseInt(normalized.slice(4, 6), 16)

  return `rgba(${r}, ${g}, ${b}, ${alpha})`
}

export const getScheduleEventColor = eventType =>
  SCHEDULE_EVENT_COLORS[eventType] ||
  SCHEDULE_EVENT_COLORS[SCHEDULE_EVENT_TYPES.GROUP_EVENT]

export const getScheduleEventBadgeStyles = eventType => {
  const color = getScheduleEventColor(eventType)

  return {
    color,
    backgroundColor: hexToRgba(color, 0.12),
  }
}

export const getScheduleEventPastAccentColor = eventType =>
  hexToRgba(getScheduleEventColor(eventType), 0.35)

export const getScheduleEventPastBadgeStyles = eventType => {
  const color = getScheduleEventColor(eventType)

  return {
    color: hexToRgba(color, 0.55),
    backgroundColor: hexToRgba(color, 0.08),
  }
}

const hasTag = (tags = [], tagSet) => tags.some(tag => tagSet.has(tag))

const isFamilyGolfTemplate = groupEvent => {
  const templateSlug = groupEvent.template?.slug
  return (
    templateSlug === 'family-golf' || hasTag(groupEvent.tags, FAMILY_GOLF_TAGS)
  )
}

const isPgaJrLeagueEvent = groupEvent =>
  hasTag(groupEvent.tags, PGA_JR_LEAGUE_TAGS) ||
  groupEvent.template?.slug === 'jr-league' ||
  groupEvent.template?.slug === 'pga-jr-league'

export const getScheduleEventType = booking => {
  if (BLOCKED_TIME_TYPENAMES.has(booking.__typename)) {
    return SCHEDULE_EVENT_TYPES.BLOCKED_TIME
  }

  if (booking.__typename === 'Session') {
    return SCHEDULE_EVENT_TYPES.PRIVATE
  }

  if (booking.__typename === 'GroupEvent') {
    if (isPgaJrLeagueEvent(booking)) {
      return SCHEDULE_EVENT_TYPES.PGA_JR_LEAGUE
    }

    if (isFamilyGolfTemplate(booking)) {
      return SCHEDULE_EVENT_TYPES.FAMILY_GOLF
    }

    return SCHEDULE_EVENT_TYPES.GROUP_EVENT
  }

  return SCHEDULE_EVENT_TYPES.GROUP_EVENT
}
